{
  "passwordConfirm": "Confirm password",
  "password": "Password",
  "8char": "8 characters minimum",
  "oneNumber": "One number",
  "oneLower": "One lowercase character",
  "oneUpper": "One uppercase character",
  "password_updated": "The password was updated with success",
  "reset_password": "Reset password",
  "reset": "Reset password",
  "go_back_on_login": " Go back on login",
  "email": "Email"
}
